import { defineElement, html, TemplateElement } from '@webtides/element-js';
import InputEvents from '../events/InputEvents';

export class DropdownControl extends TemplateElement {
    constructor() {
        super({ shadowRender: false, autoUpdate: false });
    }

    connected() {
        this._form = this.closest('form');
    }

    // prettier-ignore
    template() {
        return html`
            <div ref="control" class="dropdown-control flex items-center">
                <select ref="select" id="select-${this.name}" class="text-theme-dark bg-white" name="${this.name}">
                    ${this.options
            .map((option, index) => {
                return html`
                                <option ${this.value == option ? "selected" : ''}>${option}</option>
                            `;}).join('')}
                </select>
                <svg-icon name="chevron-down" class="absolute right-0 h-4 w-3 text-theme-1 mr-2 pointer-events-none"></svg-icon>
                ${this.help ? `<span id="${this.name}Help" class="form-help-text">${this.help}</span>` : ''}
            </div>
        `;
    }

    properties() {
        return {
            name: 'name',
            label: false,
            help: false,
            options: [],
            selected: false,
        };
    }

    events() {
        return {
            select: {
                change: () => {
                    this.dispatch('change', this.$refs.select, true);
                    this.dispatch(InputEvents.INPUT_CHANGE, this.$refs.select.value, true);
                },
            },
        };
    }

    get form() {
        return this._form;
    }
}

defineElement('dropdown-control', DropdownControl);
